"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toc = exports.title = exports.slug = exports.pageId = exports.navTitle = exports.name = exports.metaDescription = exports.default = void 0;
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("@mdx-js/react");
/*@jsxRuntime automatic @jsxImportSource react*/
// translate-ignore

const pageId = exports.pageId = 160314504509;
const slug = exports.slug = 'guides/api/crm/objects/deal-splits';
// translate-ignore
const navTitle = exports.navTitle = 'Deal splits';
const title = exports.title = 'CRM API | Deal splits';
const name = exports.name = 'CRM API | Deal splits';
const metaDescription = exports.metaDescription = 'Learn how to view and edit deal splits via API.';
const toc = exports.toc = [{
  "depth": 0,
  "id": "create-or-update-deal-splits",
  "label": "Create or update deal splits",
  "parent": null
}, {
  "depth": 0,
  "id": "retrieve-deal-splits",
  "label": "Retrieve deal splits",
  "parent": null
}];
function _createMdxContent(props) {
  const _components = Object.assign({
    h1: "h1",
    p: "p",
    em: "em",
    strong: "strong",
    a: "a",
    h2: "h2",
    code: "code",
    table: "table",
    thead: "thead",
    tr: "tr",
    th: "th",
    tbody: "tbody",
    td: "td",
    pre: "pre"
  }, (0, _react.useMDXComponents)(), props.components);
  return (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [(0, _jsxRuntime.jsx)(_components.h1, {
      children: "Deal splits"
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["If your HubSpot account has a ", (0, _jsxRuntime.jsxs)(_components.em, {
        children: [(0, _jsxRuntime.jsx)(_components.strong, {
          children: "Sales Hub"
        }), " Enterprise"]
      }), " subscription, you can set up ", (0, _jsxRuntime.jsx)(_components.a, {
        href: "https://knowledge.hubspot.com/records/split-deal-credit-among-users",
        children: "deal splits"
      }), " to split credit for deal amounts between multiple users. Once ", (0, _jsxRuntime.jsx)(_components.a, {
        href: "https://knowledge.hubspot.com/records/split-deal-credit-among-users#turn-on-deal-splits",
        children: "deal splits are turned on"
      }), " in your HubSpot account, you can use the deal splits API to create new deal splits or view and update existing splits."]
    }), "\n", (0, _jsxRuntime.jsx)(_components.h2, {
      children: "Create or update deal splits"
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["To add new splits or update existing splits for deals, make a ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "POST"
      }), " request to ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "crm/v3/objects/deals/splits/batch/upsert"
      }), "."]
    }), "\n", (0, _jsxRuntime.jsx)(_components.p, {
      children: "In your request, include the following fields for each deal:"
    }), "\n", (0, _jsxRuntime.jsxs)(_components.table, {
      children: [(0, _jsxRuntime.jsx)(_components.thead, {
        children: (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.th, {
            children: "Field"
          }), (0, _jsxRuntime.jsx)(_components.th, {
            children: "Description"
          })]
        })
      }), (0, _jsxRuntime.jsxs)(_components.tbody, {
        children: [(0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "id"
            })
          }), (0, _jsxRuntime.jsxs)(_components.td, {
            children: ["The ID of the deal. You can retrieve this via the ", (0, _jsxRuntime.jsx)(_components.a, {
              href: "/guides/api/crm/objects/deals#retrieve-deals",
              children: "deals API"
            }), "."]
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "splits"
            })
          }), (0, _jsxRuntime.jsxs)(_components.td, {
            children: ["An array that contains the user to assign a split to, and the percentage of the deal amount to assign. In the array, include the following fields:", (0, _jsxRuntime.jsx)(_components.code, {
              children: "ownerId"
            }), ": the ", (0, _jsxRuntime.jsx)(_components.a, {
              href: "/guides/api/crm/owners",
              children: "owner ID"
            }), " assigned to the HubSpot user.", (0, _jsxRuntime.jsx)(_components.code, {
              children: "percentage"
            }), ": the percentage of the deal amount to assign to the owner."]
          })]
        })]
      })]
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["When adding deal splits, the deal's owner must be included as a split owner, the split percentages must add up to 1.0, and you must meet the limits for the split user maximum and split percentage minimum set in your ", (0, _jsxRuntime.jsx)(_components.a, {
        href: "https://knowledge.hubspot.com/records/split-deal-credit-among-users#turn-on-deal-splits",
        children: "deal split settings."
      }), "If any deals included in the batch request fail validation for these requirements, the request will result in an error."]
    }), "\n", (0, _jsxRuntime.jsx)(_components.p, {
      children: "For example, to assign even deal credit to two users on a deal, your request would look like:"
    }), "\n", (0, _jsxRuntime.jsx)(_components.pre, {
      children: (0, _jsxRuntime.jsx)(_components.code, {
        className: "language-json",
        children: "///Example request body\n{\n  \"inputs\": [\n    {\n      \"id\": 5315919905,\n      \"splits\": [\n        {\n          \"ownerId\": 41629779,\n          \"percentage\": 0.5\n        },\n        {\n          \"ownerId\": 60158084,\n          \"percentage\": 0.5\n        }\n      ]\n    }\n  ]\n}\n"
      })
    }), "\n", (0, _jsxRuntime.jsx)(_components.p, {
      children: "If a deal didn't have existing splits, the splits will appear on the deal record following your request. If the deal had existing splits, they will be replaced by the splits you created in your request."
    }), "\n", (0, _jsxRuntime.jsx)(_components.h2, {
      children: "Retrieve deal splits"
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["To view split information for deals, make a ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "POST"
      }), " request to ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "crm/v3/objects/deals/splits/batch/read"
      }), ". In your request, include the ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "id"
      }), " values of the deals with splits you want to view. You can retrieve a deal's ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "id"
      }), " via the ", (0, _jsxRuntime.jsx)(_components.a, {
        href: "/guides/api/crm/objects/deals#retrieve-deals",
        children: "deals API"
      }), "."]
    }), "\n", (0, _jsxRuntime.jsx)(_components.p, {
      children: "For example, to retrieve deal splits for two deals, your request could look like:"
    }), "\n", (0, _jsxRuntime.jsx)(_components.pre, {
      children: (0, _jsxRuntime.jsx)(_components.code, {
        className: "language-json",
        children: "///Example request body\n{\n  \"inputs\": [\n    {\n      \"id\": \"5315919905\"\n    },\n    {\n      \"id\": \"17137567105\"\n    }\n  ]\n}\n"
      })
    }), "\n", (0, _jsxRuntime.jsx)(_components.p, {
      children: "For each deal, the response will include the date and time the splits were created or updated, the IDs of users splitting the deal, and the percentage of the deal amount assigned to each user."
    }), "\n", (0, _jsxRuntime.jsx)(_components.p, {
      children: "For two deals, the response would look similar to:"
    }), "\n", (0, _jsxRuntime.jsx)(_components.pre, {
      children: (0, _jsxRuntime.jsx)(_components.code, {
        className: "language-json",
        children: "///Example response\n{\n  \"status\": \"COMPLETE\",\n  \"results\": [\n    {\n      \"id\": \"17137567105\",\n      \"splits\": [\n        {\n          \"id\": \"311226010924\",\n          \"properties\": {\n            \"hs_deal_split_percentage\": \"0.5\",\n            \"hubspot_owner_id\": \"41629779\"\n          },\n          \"createdAt\": \"2024-03-11T19:55:26.219Z\",\n          \"updatedAt\": \"2024-03-11T19:55:26.219Z\",\n          \"archived\": false\n        },\n        {\n          \"id\": \"311226010925\",\n          \"properties\": {\n            \"hs_deal_split_percentage\": \"0.25\",\n            \"hubspot_owner_id\": \"60158084\"\n          },\n          \"createdAt\": \"2024-03-11T19:55:26.219Z\",\n          \"updatedAt\": \"2024-03-11T19:55:26.219Z\",\n          \"archived\": false\n        },\n        {\n          \"id\": \"311226010926\",\n          \"properties\": {\n            \"hs_deal_split_percentage\": \"0.25\",\n            \"hubspot_owner_id\": \"61891281\"\n          },\n          \"createdAt\": \"2024-03-11T19:55:26.219Z\",\n          \"updatedAt\": \"2024-03-11T19:55:26.219Z\",\n          \"archived\": false\n        }\n      ]\n    },\n    {\n      \"id\": \"5315919905\",\n      \"splits\": [\n        {\n          \"id\": \"57675010822\",\n          \"properties\": {\n            \"hs_deal_split_percentage\": \"0.3333\",\n            \"hubspot_owner_id\": \"81538190\"\n          },\n          \"createdAt\": \"2021-06-16T21:04:09.264Z\",\n          \"updatedAt\": \"2021-06-16T21:04:09.264Z\",\n          \"archived\": false\n        },\n        {\n          \"id\": \"57675010821\",\n          \"properties\": {\n            \"hs_deal_split_percentage\": \"0.3333\",\n            \"hubspot_owner_id\": \"81426347\"\n          },\n          \"createdAt\": \"2021-06-16T21:04:09.264Z\",\n          \"updatedAt\": \"2021-06-16T21:04:09.264Z\",\n          \"archived\": false\n        },\n        {\n          \"id\": \"57675010820\",\n          \"properties\": {\n            \"hs_deal_split_percentage\": \"0.3334\",\n            \"hubspot_owner_id\": \"60158084\"\n          },\n          \"createdAt\": \"2021-06-16T21:04:09.264Z\",\n          \"updatedAt\": \"2021-06-16T21:04:09.264Z\",\n          \"archived\": false\n        }\n      ]\n    }\n  ],\n  \"startedAt\": \"2024-03-11T19:56:42.555Z\",\n  \"completedAt\": \"2024-03-11T19:56:42.596Z\"\n}\n"
      })
    })]
  });
}
function MDXContent(props = {}) {
  const {
    wrapper: MDXLayout
  } = Object.assign({}, (0, _react.useMDXComponents)(), props.components);
  return MDXLayout ? (0, _jsxRuntime.jsx)(MDXLayout, Object.assign({}, props, {
    children: (0, _jsxRuntime.jsx)(_createMdxContent, props)
  })) : _createMdxContent(props);
}
var _default = exports.default = MDXContent;